<template>
  <div class="page-wrapper">
    <div class="content container-fluid waajo-session-page">
      <div class="waajo-session-page-head">
        <div class="waajo-session-page-copy">
          <span class="waajo-session-page-eyebrow">
            <i class="fa fa-comments"></i>
            AI Chat
          </span>
          <h3 class="waajo-session-page-title">Sesi AI Chat</h3>
          <p class="waajo-session-page-subtitle">
            Pantau dan kelola percakapan pelanggan yang ditangani oleh AI.
          </p>
        </div>
      </div>

      <div class="waajo-session-stats">
        <div class="waajo-session-stat">
          <span class="waajo-session-stat-icon">
            <i class="fa fa-signal"></i>
          </span>
          <div class="waajo-session-stat-copy">
            <span class="waajo-session-stat-label">Status AI</span>
            <span v-if="statsLoading" class="waajo-session-stat-sk"></span>
            <template v-else-if="statusKnown">
              <span
                class="waajo-session-ai-status"
                :class="aiAvailable ? 'is-available' : 'is-unavailable'"
              >
                <span class="waajo-session-ai-dot"></span>
                {{ aiAvailable ? "Available" : "Unavailable" }}
                <small v-if="aiAvailable && aiDetail.trial_status == 1">Free</small>
              </span>
              <small class="waajo-session-stat-note">
                {{ aiAvailable ? "AI siap merespons pelanggan" : "AI belum aktif" }}
              </small>
            </template>
            <template v-else>
              <strong class="waajo-session-stat-value">&mdash;</strong>
              <small class="waajo-session-stat-note">Status belum dapat dimuat</small>
            </template>
          </div>
        </div>

        <div class="waajo-session-stat">
          <span class="waajo-session-stat-icon">
            <i class="fa fa-bolt"></i>
          </span>
          <div class="waajo-session-stat-copy">
            <span class="waajo-session-stat-label">Saldo Token AI</span>
            <span v-if="statsLoading" class="waajo-session-stat-sk"></span>
            <strong v-else-if="tokenStatsLoaded" class="waajo-session-stat-value">
              {{ nFormatter(rowTotalTokenAI.total_tokens) }}
            </strong>
            <strong v-else class="waajo-session-stat-value">&mdash;</strong>
            <small class="waajo-session-stat-note">
              {{ tokenStatsLoaded ? "Token tersedia untuk AI" : "Belum dapat dimuat" }}
            </small>
          </div>
          <router-link to="/ai/pricing" class="waajo-session-topup">
            Top Up
          </router-link>
        </div>

        <div class="waajo-session-stat">
          <span class="waajo-session-stat-icon">
            <i class="fa fa-file-text-o"></i>
          </span>
          <div class="waajo-session-stat-copy">
            <span class="waajo-session-stat-label">Token Digunakan</span>
            <span v-if="statsLoading" class="waajo-session-stat-sk"></span>
            <strong v-else-if="tokenStatsLoaded" class="waajo-session-stat-value is-used">
              {{ nFormatter(rowTotalTokenAI.total_tokens_used) }}
            </strong>
            <strong v-else class="waajo-session-stat-value">&mdash;</strong>
            <small class="waajo-session-stat-note">
              {{ tokenStatsLoaded ? "Total pemakaian token AI" : "Belum dapat dimuat" }}
            </small>
          </div>
        </div>
      </div>

      <ai-list-sessions />
    </div>
  </div>
</template>

<script>
import { nFormatter } from "@/utils/helper";
import AiListSessions from "./components/AiListSessions.vue";

export default {
  components: {
    AiListSessions
  },
  data() {
    return {
      rowTotalTokenAI: {
        total_tokens: "0",
        total_tokens_used: "0"
      },
      aiDetail: {
        ai_engine: "",
        trial_status: 0,
        trial_expire: 0
      },
      dataParam: {
        api_key: ""
      },
      tokenStatsLoaded: false,
      balanceLoaded: false,
      keyLoaded: false,
      statsLoading: true
    };
  },
  computed: {
    aiBalance() {
      return (
        this.$store.state.aiKey.aiBalance || {
          is_available: false,
          balance_infos: []
        }
      );
    },
    aiAvailable() {
      return (
        (this.aiBalance && this.aiBalance.is_available === true) ||
        !!this.dataParam.api_key
      );
    },
    statusKnown() {
      return this.balanceLoaded || this.keyLoaded;
    }
  },
  created() {
    this.loadStats();
  },
  methods: {
    nFormatter(value) {
      return nFormatter(value);
    },
    async loadStats() {
      this.statsLoading = true;
      const tasks = [
        this.getAIKey(),
        this.getBalance(),
        this.getAIDetail(),
        this.getTotalTokenAI()
      ];
      await Promise.all(
        tasks.map(task => {
          return task.catch(() => null);
        })
      );
      this.statsLoading = false;
    },
    getTotalTokenAI() {
      return this.$store.dispatch("dashboard/TotalTokenAI").then(response => {
        const data = response && response.data ? response.data : {};
        this.rowTotalTokenAI = {
          total_tokens: data.total_tokens || "0",
          total_tokens_used: data.total_tokens_used || "0"
        };
        this.tokenStatsLoaded = true;
      });
    },
    getAIDetail() {
      return this.$store.dispatch("aiKey/getDetail").then(response => {
        this.aiDetail = (response && response.data) || this.aiDetail;
      });
    },
    getAIKey() {
      return this.$store.dispatch("aiKey/getAIKey").then(response => {
        const data = response && response.data ? response.data : "";
        this.dataParam.api_key = typeof data === "string" ? data : "";
        this.keyLoaded = true;
      });
    },
    getBalance() {
      return this.$store.dispatch("aiKey/getBalance").then(() => {
        this.balanceLoaded = true;
      });
    }
  },
  name: "settingsAIKey"
};
</script>

<style scoped>
.waajo-session-page {
  padding-top: 22px;
  padding-bottom: 28px;
  color: #344054;
}

.waajo-session-page-head {
  margin-bottom: 18px;
}

.waajo-session-page-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  color: #f39c12;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.waajo-session-page-title {
  margin: 0;
  color: #101828;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.waajo-session-page-subtitle {
  margin: 6px 0 0;
  color: #667085;
  font-size: 14px;
  line-height: 1.5;
}

.waajo-session-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.waajo-session-stat {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
  padding: 13px 14px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.035);
}

.waajo-session-stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #f39c12;
  background: #fff7e8;
  border-radius: 11px;
  font-size: 16px;
}

.waajo-session-stat-copy {
  flex: 1 1 auto;
  min-width: 0;
}

.waajo-session-stat-label {
  display: block;
  margin-bottom: 3px;
  color: #667085;
  font-size: 13px;
  font-weight: 600;
}

.waajo-session-stat-value {
  display: block;
  overflow: hidden;
  color: #101828;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-session-stat-value.is-used {
  color: #d92d20;
}

.waajo-session-stat-note {
  display: block;
  margin-top: 3px;
  overflow: hidden;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-session-ai-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #344054;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
}

.waajo-session-ai-status small {
  display: inline-flex;
  padding: 2px 6px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.waajo-session-ai-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

.waajo-session-ai-status.is-available {
  color: #067647;
}

.waajo-session-ai-status.is-available .waajo-session-ai-dot {
  background: #12b76a;
  box-shadow: 0 0 0 3px rgba(18, 183, 106, 0.16);
}

.waajo-session-ai-status.is-unavailable {
  color: #b42318;
}

.waajo-session-ai-status.is-unavailable .waajo-session-ai-dot {
  background: #f04438;
  box-shadow: 0 0 0 3px rgba(240, 68, 56, 0.14);
}

.waajo-session-topup {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  height: 34px;
  padding: 0 12px;
  color: #b36b00;
  background: #ffffff;
  border: 1px solid #f6d49b;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.waajo-session-topup:hover,
.waajo-session-topup:focus {
  color: #8f5600;
  background: #fffaf1;
  border-color: #f39c12;
  text-decoration: none;
}

.waajo-session-stat-sk {
  display: inline-block;
  width: 92px;
  height: 20px;
  margin: 3px 0;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 37%, #eef2f7 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: waajo-session-stat-shimmer 1.4s ease infinite;
}

@keyframes waajo-session-stat-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

@media (max-width: 1199px) {
  .waajo-session-stats {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .waajo-session-stat:last-child {
    grid-column: 1 / -1;
  }
}

@media (max-width: 767px) {
  .waajo-session-page {
    padding-top: 18px;
  }

  .waajo-session-page-title {
    font-size: 23px;
  }

  .waajo-session-stats {
    grid-template-columns: minmax(0, 1fr);
  }

  .waajo-session-stat:last-child {
    grid-column: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/aiKey.vue